// src/components/general/Personas/PersonasTabs.jsx
import { useState } from 'react';
import AreasNegocioTab from '../../../../RH/Components/Tabs/EmpleadosAreaNegocioTab';
import NivelesJerarquicosTab from '../../../../RH/Components/Tabs/EmpleadosNivelJerarquicoTab';
import PuestosTab from '../../../../RH/Components/Tabs/EmpleadosPuestoTab';
import UnidadesOrgTab from '../../../../RH/Components/Tabs/UnidadesOrgEmpleadoTab';
import ZonasGeograficasTab from '../../../../RH/Components/Tabs/EmpleadosZonasGeograficasTab';
import TurnosTab from '../../../../RH/Components/Tabs/EmpleadosTurnosTab';
import AlertDialog from '../../../../Lms/Components/Shared/AlertDialog';

const tabsList = [
  { key: 'areasNegocio', label: 'Areas de Negocio' },
  { key: 'nivelJerarquico', label: 'Niveles Jerarquicos' },
  { key: 'puestos', label: 'Puestos' },
  { key: 'unidadesOrganizacionales', label: 'Unidades Organizacionales' },
  { key: 'zonasGeograficas', label: 'Zonas Geográficas' },
  { key: 'turnos', label: 'Turnos' },
  // Luego agregas: teléfonos, emails, etc.
];

export default function EmpleadosTabs({ personId }) {
  const [active, setActive] = useState('areasNegocio');
  const [isDirty, setIsDirty] = useState(false);
  const [alertDialog, setAlertDialog] = useState({ open: false, title: '', message: '', variant: 'warning' });
  const hasValidContext = Number(personId || 0) > 0;

  if (!hasValidContext) {
    return (
      <div className="person-tabs-disabled">
        <span>
          Selecciona o crea un empleado y pulsa <b>Editar</b> para gestionar sus datos
          relacionados.
        </span>
      </div>
    );
  }

  return (
    <div className="person-tabs-wrap">
      <div className="person-tabs-bar">
        {tabsList.map((t) => {
          const disabledStyles = (isDirty && active !== t.key) ? { opacity: 0.5, cursor: 'not-allowed' } : {};
          return (
            <button
              key={t.key}
              className={`person-tab ${active === t.key ? 'is-active' : ''}`}
              style={disabledStyles}
              onClick={() => {
                if (isDirty && active !== t.key) {
                  setAlertDialog({
                    open: true,
                    title: 'Cambios sin guardar',
                    message: 'Tienes cambios sin guardar en la pestaña actual. Por favor guárdalos o cancélalos antes de cambiar.',
                    variant: 'warning'
                  });
                  return;
                }
                setActive(t.key);
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      <div className="person-tab-panel">
        {active === 'areasNegocio' && <AreasNegocioTab fkValue={personId} onDirtyChange={setIsDirty} />}
        {active === 'nivelJerarquico' && <NivelesJerarquicosTab fkValue={personId} onDirtyChange={setIsDirty} />}
        {active === 'puestos' && <PuestosTab fkValue={personId} onDirtyChange={setIsDirty} />}
        {active === 'unidadesOrganizacionales' && <UnidadesOrgTab fkValue={personId} onDirtyChange={setIsDirty} />}
        {active === 'zonasGeograficas' && <ZonasGeograficasTab fkValue={personId} onDirtyChange={setIsDirty} />}
        {active === 'turnos' && <TurnosTab fkValue={personId} onDirtyChange={setIsDirty} />}
      </div>

      {alertDialog.open && (
        <AlertDialog
          open={alertDialog.open}
          onClose={() => setAlertDialog(prev => ({ ...prev, open: false }))}
          title={alertDialog.title}
          message={alertDialog.message}
          variant={alertDialog.variant}
        />
      )}
    </div>
  );
}
